import { ConversationObject } from '../../params/redux/watercooler';
import { formatTimeUptoNow } from '../../helper';
import { RootState } from '../../redux/store';
import { useSelector } from 'react-redux';
import { Visibility } from '@mui/icons-material';
import { Box, Button, Typography } from '@mui/material';
import { brand, gray } from '../../theme/themePrimitives';

interface MessageSectionProps {
    conversations: ConversationObject[];
    loaders: boolean
}

const MessageSection = ({ conversations }: MessageSectionProps) => {
    const { currentUser } = useSelector((state: RootState) => state.app);

    return (
        <Box
            border={`1px solid ${gray[100]}`}
            p={2}
            minHeight="50vh"
            maxHeight="50vh"
            overflow="auto"
            bgcolor="rgb(248, 247, 250)"
            sx={{
                borderTopLeftRadius: '10px',
                borderTopRightRadius: '10px'
            }}
            display="flex"
            flexDirection="column-reverse"
        >
            {
                conversations.map((conversation, index) => (
                    <Box key={index} mt={1}>
                        <Box display="flex" flexDirection="column" alignItems={currentUser?.id === conversation.user.id ? 'end' : 'start'}>
                            <Typography variant="subtitle1" fontWeight="bold">
                                {`${conversation.user.first_name} ${conversation.user.last_name}`}
                            </Typography>
                            <Box
                                bgcolor={currentUser?.id === conversation.user.id ? brand[300] : gray[300]}
                                px={2}
                                paddingY="1px"
                                borderRadius={1}
                                width="max-content"
                                display="flex"
                                alignItems="center"
                                flexDirection="column"
                                justifyContent="center"
                                py={1}
                            >
                                <Box
                                    color={currentUser?.id === conversation.user.id ? 'white' : 'black'}
                                    width="max-content"
                                    height="max-content"
                                    dangerouslySetInnerHTML={{ __html: conversation.message }}
                                />
                                {conversation.file_url && <Button variant="outlined" color={currentUser?.id === conversation.user.id ? 'primary' : 'secondary'} >
                                    <a
                                        href={`${process.env.REACT_APP_FILE_PATH}${conversation.file_url}`}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        style={{
                                            textDecoration: 'underline',
                                            color: currentUser?.id === conversation.user.id ? 'white' : 'black'
                                        }}
                                    >
                                        <Box display="flex" gap={1} alignItems="center"><Visibility /> View File</Box>
                                    </a>
                                </Button>}
                            </Box>
                            <Typography variant="body2" color="textSecondary">
                                {conversation.created_at && formatTimeUptoNow(conversation.created_at)}
                            </Typography>
                        </Box>
                        {/* FOR USER PHOTO */}
                        <Box></Box>
                    </Box>))
            }
        </Box>
    );
};

export default MessageSection;